import { createTheme, ThemeProvider } from "@mui/material/styles";
import RamanAnalysis from "./components/analysis/RamanAnalysis";
import Footer from "./components/footer/Footer";
import Hero from "./components/hero/Hero";
import HowItWorks from "./components/how-it-works/HowItWorks";
import Team from "./components/team/Team";

const theme = createTheme({
    palette: {
        primary: {
            main: "#3949ab",
        },
        secondary: {
            main: "#2E3440",
        },
        error: {
            main: "#ffcdd2",
        },
        success: {
            main: "#3C5232"
        }
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <Hero />
                <HowItWorks />
                <RamanAnalysis />
                <Team />
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default App;
